<template>
<div id="secure">

    <NewTopMenu />
    <div class="container">

        <div class="columns">
            <div class="column is-12">
                <div class="card is-hidden1">
                    <div class="card-header" style="padding: 10px;">
                        <b-select id="category" name="category" v-model="category" size="is-small" style="margin-left: 10px;" @input="getRevokedSubmissions(1)">
                            <option selected value="school">All</option>
                            <option v-for="kelas in kelasList" :key="kelas._id" :value="kelas._id">{{ kelas.level }} {{ kelas.name }}</option>
                        </b-select>
                        <b-select id="behaviorID" name="behaviorID" v-model="behaviorID" size="is-small" style="margin-left: 10px;"  @input="getRevokedSubmissions()">
                            <option selected value="all">All Behaviors</option>
                            <option v-for="behavior in behaviorList" :key="behavior._id" :value="behavior._id">{{ behavior.name }}</option>
                        </b-select>
                        <b-select id="durationMonthly" name="durationMonthly" v-model="durationMonthly" size="is-small" style="margin-left: 10px;" @input="getRevokedSubmissions()">
                            <option selected value="1">January</option>
                            <option selected value="2">February</option>
                            <option selected value="3">March</option>
                            <option selected value="4">April</option>
                            <option selected value="5">May</option>
                            <option selected value="6">June</option>
                            <option selected value="7">July</option>
                            <option selected value="8">August</option>
                            <option selected value="9">September</option>
                            <option selected value="10">October</option>
                            <option selected value="11">November</option>
                            <option selected value="12">December</option>
                        </b-select>
                    </div>
                    <div class="card-content">
                        <loading :active.sync="isLoading" 
                            :can-cancel="false" 
                            :is-full-page="true">
                        </loading>
                        <div class="columns" v-show="submissionList.length == 0">
                            No revoked submissions found.
                        </div>
                        <div class="columns bottom-border" v-show="submissionList.length > 0">
                            <div class="column is-1">#</div>
                            <div class="column">Student</div>
                            <div class="column" v-show="category=='school'">Class</div>
                            <div class="column">Behavior</div>
                            <div class="column">Date &amp; Time</div>
                            <div class="column">Total Points</div>
                            <div class="column">Remarks</div>
                            <div class="column">Awarded by</div>
                            <div class="column is-1" style="padding: 0px; text-align: center;">
                                <a class="button is-warning is-small" v-on:click="unRevokePoints()">UnRevoke</a><br/>
                                <small><a v-on:click="checkAll">Check all</a></small>
                            </div>
                        </div>
                        <div class="columns" v-for="(submission,index) in sortByDate(submissionList)" :key="submission._id" v-show="submissionList.length > 0">
                            <div class="column is-1">{{ index + 1 }}</div>
                            <div class="column">{{ submission.studentID.firstName }} {{ submission.studentID.lastName }}</div>
                            <div class="column" v-show="category=='school'">{{ submission.kelasID.level }} {{ submission.kelasID.name }}</div>
                            <div class="column">{{ submission.positiveID.name }}</div>
                            <div class="column">{{ displayDate(submission.actionDate) }}, {{ submission.actionTime }} </div>                            
                            <div class="column">{{ roundTo2DecimalPlaces(submission.points) }} x {{ submission.multiply }} = <b>{{ roundTo2DecimalPlaces(submission.totalPoints) }}</b></div>
                            <div class="column">{{ displayInfo(submission.dataType,submission.remarks,submission.status) }}</div>
                            <div class="column">{{ submission.teacherID.firstName }} {{ submission.teacherID.lastName }}</div>
                            <div class="column is-1"><center><input type="checkbox"  :value="setCheckedValue(submission.dataType,submission._id,submission.studentID._id,submission.actionDate)" :id="setCheckedValue(submission.dataType,submission._id,submission.studentID._id,submission.actionDate)" v-model="submission.checked"></center></div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
</template>

<script>
import NewTopMenu from "./NewTopMenu";
import axios from "axios";
import { ToastProgrammatic as Toast } from 'buefy'
import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css';
import "./public/style.scss";
const helper = require("../../config/helper")

export default {
    name: "UnRevoke",
    components: {
        NewTopMenu,
        Loading,
    },
    data() {
        return {
            schoolID: "",
            behaviorID: "all",
            kelasList: [],
            behaviorList: [],
            submissionList: [],
            topClasses: [],
            isLoading: false,
            isLoading1: false,
            behaviorName: "",
            category: "school",
            duration: "monthly",
            durationMonthly: 0,
            durationYearly: 0,
            durationDisplay: ""
        };
    },
    beforeMount() {
        this.$emit("authenticated", true);
    },
    created() {
        this.schoolID = localStorage.getItem('schoolID');

        var today = new Date();
        var dd = today.getDate();
        var mm = today.getMonth()+1; //January is 0!
        this.durationYearly = today.getFullYear();
        this.durationMonthly = mm;

        this.getClassList()
        this.getBehaviorList()
        this.getRevokedSubmissions()
    },
    mounted(){
    },
    methods: {
        getRevokedSubmissions(){
            let self = this
            self.isLoading = true

            var durationDisplay = "";
            if ((self.duration == 2020) || (self.duration == 2019)){
                durationDisplay = self.duration
            }else{
                var displayMonth = helper.displayMonth(self.duration)
                durationDisplay = displayMonth + " " + self.durationYearly
            }

            axios.defaults.responseType = 'json'
            axios.post(process.env.NEW_ENDPOINT + '/submissions/revokedList', {
                token: localStorage.getItem('jwtTokenV2'),
                email: localStorage.getItem('email'),
                category: self.category,
                behaviorID: self.behaviorID,
                duration: self.duration,
                month: self.durationMonthly,
                year: self.durationYearly
            })
            .then(response => {
                self.submissionList = response.data
                console.log("132 submissionList.length: " + self.submissionList.length)
                self.isLoading = false
            })
            .catch(e => {
                console.log(e)
                self.isLoading = false
                if (e.response.status === 401) {                            
                    Toast.open({
                        message: "Unauthorized access. Please re-login.",
                        type: 'is-danger', //is-white, is-black, is-light, is-dark, is-primary, is-info, is-success, is-warning, is-danger
                        duration: 5000
                    })
                } else {
                    Toast.open({
                        message: 'Error: ' + e.response.data.msg,
                        type: 'is-danger', //is-white, is-black, is-light, is-dark, is-primary, is-info, is-success, is-warning, is-danger
                        duration: 5000
                    })
                }
            })
        },        
        unRevokePoints(){
            let self = this;
            var pointsToRevoke = [];

            self.submissionList.forEach(function(element) {
                if (element.checked){
                    var elementID = self.setCheckedValue(element.dataType,element._id,element.studentID._id,element.actionDate)
                    pointsToRevoke.push(elementID)
                }
            });
    
            console.log("183 pointsToRevoke.length: " + pointsToRevoke.length)
            console.log(pointsToRevoke)
            if (pointsToRevoke.length > 0){

                this.$swal({
                    title: "Are you sure?",
                    text: "Are you sure you want to unrevoke (recover) the selected submissions?",
                    showCancelButton: true,
                    confirmButtonText: 'Yes, recover',
                    cancelButtonText: 'No, cancel',
                    showCloseButton: true
                }).then((result) => {
                    if (result.value){

                        axios.defaults.responseType = 'json'
                        axios.post(process.env.NEW_ENDPOINT + '/submissions/unrevoke/', {
                            token: localStorage.getItem('jwtTokenV2'),
                            email: localStorage.getItem('email'),
                            pointsToRevoke: pointsToRevoke
                        })
                        .then(response => {
                            console.log("313 response.data: ")
                            console.log(response.data)
                            self.isLoading = false
                            
                            if (response.data.success == false) {
                                Toast.open({
                                    message: response.data.msg,
                                    type: 'is-danger', //is-white, is-black, is-light, is-dark, is-primary, is-info, is-success, is-warning, is-danger
                                    duration: 5000
                                })
                            } else {
                                Toast.open({
                                    color: 'is-dark', //is-white, is-black, is-light, is-dark, is-primary, is-info, is-success, is-warning, is-danger
                                    message: response.data.msg,
                                    type: 'is-success',
                                    duration: 3000
                                })
                            }
                            self.getRevokedSubmissions()
                        })
                        .catch(e => {
                            console.log(e)
                            self.isLoading = false
                            if (e.response.status === 401) {                            
                                Toast.open({
                                    message: "Unauthorized access. Please re-login.",
                                    type: 'is-danger', //is-white, is-black, is-light, is-dark, is-primary, is-info, is-success, is-warning, is-danger
                                    duration: 5000
                                })
                            } else {
                                Toast.open({
                                    message: 'Error: ' + e.response.data.msg,
                                    type: 'is-danger', //is-white, is-black, is-light, is-dark, is-primary, is-info, is-success, is-warning, is-danger
                                    duration: 5000
                                })
                            }
                        })
                    }
                })
            }else{
                Toast.open({
                    message: "Please select the submission(s) you want to revoke first",
                    type: 'is-warning', //is-white, is-black, is-light, is-dark, is-primary, is-info, is-success, is-warning, is-danger
                    duration: 3000
                })
                return false;
            }            
        },
        checkAll: function() {
            this.submissionList = this.submissionList.map(behavior => ({ ...behavior,
                checked: !this.isAllChecked
            }))
            this.isAllChecked = !this.isAllChecked
        },
        setCheckedValue(dataType,id,studentID,actionDate){
            return "1:" + dataType + "|2:" + id + "|3:" + studentID + "|4:" + actionDate
        },
        displayDate(date){
            try{
                var getYear = date.substring(0,4);
                var getMonth = date.substring(4,6);
                var getDay = date.substring(6);

                return getDay + "/" + getMonth + "/" + getYear;
            }catch(err){
                console.log(err)
                return date;
            }
        },
        displayInfo(dataType,remarks,status){
            if (dataType == 2){
                if (status == 2){
                    return "Late"
                }else{
                    return "On-Time"
                }
            }else{
                return remarks
            }
        },
        getClassList(){
            let self = this

            axios.defaults.responseType = 'json'
            axios.post(process.env.NEW_ENDPOINT + '/classes/list/', {
                token: localStorage.getItem('jwtTokenV2'),
                email: localStorage.getItem('email'),
            })
            .then(response => {
                self.kelasList = response.data.kelasList                
            })
            .catch(e => {
                console.log(e)
            })
        },
        getBehaviorList(){
            let self = this

            axios.defaults.responseType = 'json'
            axios.post(process.env.NEW_ENDPOINT + '/behaviors/list/', {
                token: localStorage.getItem('jwtTokenV2'),
                email: localStorage.getItem('email'),
            })
            .then(response => {
                self.behaviorList = response.data                
            })
            .catch(e => {
                console.log(e)
            })
        },
        sortByDate(arrays){
            return _.orderBy(arrays, 'actionDate', 'desc'); //we're using the magical lodash function here to sort by points and return the top needed
        },
        roundTo2DecimalPlaces(points){  //use lodash to round the points to 2 decimal places
            return _.round(points, 2)
            // return _.round(points, 2).toFixed(2)
        },
        goOverallAnalysis() {
            this.$router.push({
                name: "OverallAnalysis"
            });
        },
    },
};
</script>

<style scoped>
.bottom-border{
    border-bottom: 1px solid #CCC
}
.container{
    padding: 10px;
}
.text-center{
    text-align: center;
}
</style>


// WEBPACK FOOTER //
// src/components/UnRevoke.vue